
// Import vendor modules.
import Alpine from "@alpinejs/csp";

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

Alpine.data( "podt7m_Nav", Nav );
Alpine.data( "podt7m_Theme", Theme );

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

function Nav() {

	return {
		close,
		isOpen,
		open,
		toggleMenu,
	};

	// ---
	// LIFE-CYCLE METHODS.
	// ---

	// ---
	// PUBLIC METHODS.
	// ---

	function close() {

		this.$refs.menu.classList.remove( "open" );

	}


	function open() {

		this.$refs.menu.classList.add( "open" );

	}


	function toggleMenu() {

		if ( this.isOpen() ) {

			this.close();

		} else {

			this.open();

		}

	}

	// ---
	// PRIVATE METHODS.
	// ---

	/**
	* I determine if the menu is currently toggled open.
	*/
	function isOpen() {

		return this.$refs.menu.classList.contains( "open" );

	}

}

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

function Theme() {

	return {
		setTheme,
	};

	// ---
	// PUBLIC METHODS.
	// ---

	/**
	* I persist the theme preference for the site.
	*/
	function setTheme( event ) {

		if ( ! window.localStorage || ! window.matchMedia ) {

			return;

		}

		var target = event.currentTarget;
		var theme = target.dataset.theme;
		var prefersDark = window.matchMedia( "( prefers-color-scheme: dark )" )
			.matches
		;
		var prefersLight = ! prefersDark;


		document.documentElement
			.setAttribute( "data-theme", theme )
		;

		// When the user toggles the theme, we want to, if possible, UNSET the persisted
		// value so that we can keep the theme in alignment with the system preferences.
		// So, if the user is toggling the theme back to one that matches the current
		// system preferences, then we want REMOVE the storage item so that any system-
		// level changes will be reflected implicitly in the future.
		// --
		// Caution: Some browsers throw an error when accessing the local storage API even
		// when it exists.
		try {

			if (
				( ( theme === "light" ) && prefersLight ) ||
				( ( theme === "dark" ) && prefersDark )
				) {

				localStorage.removeItem( "theme" );

			} else {

				localStorage.setItem( "theme", theme );

			}

		} catch ( error ) {

			console.warn( "Local storage access error", error );

		}

	}

}
